import { render, staticRenderFns } from "./GrindingTwo.vue?vue&type=template&id=67159f5c&scoped=true"
import script from "./GrindingTwo.vue?vue&type=script&lang=js"
export * from "./GrindingTwo.vue?vue&type=script&lang=js"
import style0 from "./GrindingTwo.vue?vue&type=style&index=0&id=67159f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67159f5c",
  null
  
)

export default component.exports